<template>
  <div>
    <Breadtabsheader/>
    <div class="h-content w-content">
      <!--查询表单-->
      <div class="h-piece">
        <div class="h-formBox">
          <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder" ref="form">
            <div class="h-thirdColumn w-newColumn">
              <el-form-item label="年份" prop="year">
                <el-date-picker
                    style="width: 100%;"
                    v-model="q.year"
                    type="year"
                    value-format="yyyy"
                    placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="区域" prop="areaCode">
                <brselect category="YLRegion" :v="q.areaCode" v-model="q.areaCode" :clearable="true"/>
              </el-form-item>
            </div>
            <div class="h-formBtnOut h-columnCenter">
              <el-button class="h-btn h-formBtn" @click="search">检索</el-button>
              <el-button class="h-btn h-formBtn h-bgwhite" @click="reset">重置</el-button>
            </div>
          </el-form>
        </div>
      </div>
      <!--展示表格-->
      <div class="h-table h-mrt30">
        <el-table :model="q"
                  ref="q"
                  :data="tableData"
                  stripe
                  style="width: 100%"
                  :border="true"
                  :summary-method="getSummaries"
                  show-summary
                  max-height="530"
        >
          <el-table-column
              prop="areaCode"
              :show-overflow-tooltip="true"
              label="区域"
              width="80"
              fixed
          >
          </el-table-column>
          <el-table-column
              prop="oneLevelAgent"
              :show-overflow-tooltip="true"
              label="一级经销商编码"
              width="120"
              fixed
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{ scope.row.oneLevelAgent }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="oneLevelAgentName"
              :show-overflow-tooltip="true"
              label="一级经销商名称"
              width="180"
              fixed
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{ scope.row.oneLevelAgentName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="field"
              :show-overflow-tooltip="true"
              label="领域"
              width="100"
              fixed
          >
            <template slot-scope="scope">
              <div>
                {{scope.row.field|dictname('fl_field')}}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="1月分销商上平台" :show-overflow-tooltip="true">
            <el-table-column
                prop="goalNum1"
                :show-overflow-tooltip="true"
                label="目标数量"
                width="100"
            >
            </el-table-column>
            <el-table-column
                prop="fxAgentNum1"
                :show-overflow-tooltip="true"
                label="实际数量"
                width="100"
            >
              <template slot-scope="scope">
                <div class="h-line w-line" @click="chakan(scope.row,1)">{{ scope.row.fxAgentNum1 }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="sub1"
                :show-overflow-tooltip="true"
                label="差异(实际-目标)"
                width="100"
            >
            </el-table-column>
<el-table-column
                prop="sale1"
                :show-overflow-tooltip="true"
                label="下单金额"
                width="100"
            >
            </el-table-column>
            <el-table-column
                prop="service1"
                :show-overflow-tooltip="true"
                label="安装金额"
                width="100"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column label="2月分销商上平台" :show-overflow-tooltip="true">
            <el-table-column
                prop="goalNum2"
                :show-overflow-tooltip="true"
                label="目标数量"
                width="100"
            >
            </el-table-column>
            <el-table-column
                prop="fxAgentNum2"
                :show-overflow-tooltip="true"
                label="实际数量"
                width="100"
            >
              <template slot-scope="scope">
                <div class="h-line w-line" @click="chakan(scope.row,2)">{{ scope.row.fxAgentNum2 }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="sub2"
                :show-overflow-tooltip="true"
                label="差异(实际-目标)"
                width="100"
            >
            </el-table-column>
<el-table-column
                prop="sale2"
                :show-overflow-tooltip="true"
                label="下单金额"
                width="100"
            >
            </el-table-column>
            <el-table-column
                prop="service2"
                :show-overflow-tooltip="true"
                label="安装金额"
                width="100"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column label="3月分销商上平台" :show-overflow-tooltip="true">
            <el-table-column
                prop="goalNum3"
                :show-overflow-tooltip="true"
                label="目标数量"
                width="100"
            >
            </el-table-column>
            <el-table-column
                prop="fxAgentNum3"
                :show-overflow-tooltip="true"
                label="实际数量"
                width="100"
            >
              <template slot-scope="scope">
                <div class="h-line w-line" @click="chakan(scope.row,3)">{{ scope.row.fxAgentNum3 }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="sub3"
                :show-overflow-tooltip="true"
                label="差异(实际-目标)"
                width="100"
            >
            </el-table-column>
<el-table-column
                prop="sale3"
                :show-overflow-tooltip="true"
                label="下单金额"
                width="100"
            >
            </el-table-column>
            <el-table-column
                prop="service3"
                :show-overflow-tooltip="true"
                label="安装金额"
                width="100"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column label="4月分销商上平台" :show-overflow-tooltip="true">
            <el-table-column
                prop="goalNum4"
                :show-overflow-tooltip="true"
                label="目标数量"
                width="100"
            >
            </el-table-column>
            <el-table-column
                prop="fxAgentNum4"
                :show-overflow-tooltip="true"
                label="实际数量"
                width="100"
            >
              <template slot-scope="scope">
                <div class="h-line w-line" @click="chakan(scope.row,4)">{{ scope.row.fxAgentNum4 }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="sub4"
                :show-overflow-tooltip="true"
                label="差异(实际-目标)"
                width="100"
            >
            </el-table-column>
<el-table-column
                prop="sale4"
                :show-overflow-tooltip="true"
                label="下单金额"
                width="100"
            >
            </el-table-column>
            <el-table-column
                prop="service4"
                :show-overflow-tooltip="true"
                label="安装金额"
                width="100"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column label="5月分销商上平台" :show-overflow-tooltip="true">
            <el-table-column
                prop="goalNum5"
                :show-overflow-tooltip="true"
                label="目标数量"
                width="100"
            >
            </el-table-column>
            <el-table-column
                prop="fxAgentNum5"
                :show-overflow-tooltip="true"
                label="实际数量"
                width="100"
            >
              <template slot-scope="scope">
                <div class="h-line w-line" @click="chakan(scope.row,5)">{{ scope.row.fxAgentNum5 }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="sub5"
                :show-overflow-tooltip="true"
                label="差异(实际-目标)"
                width="100"
            >
            </el-table-column>
<el-table-column
                prop="sale5"
                :show-overflow-tooltip="true"
                label="下单金额"
                width="100"
            >
            </el-table-column>
            <el-table-column
                prop="service5"
                :show-overflow-tooltip="true"
                label="安装金额"
                width="100"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column label="6月分销商上平台" :show-overflow-tooltip="true">
            <el-table-column
                prop="goalNum6"
                :show-overflow-tooltip="true"
                label="目标数量"
                width="100"
            >
            </el-table-column>
            <el-table-column
                prop="fxAgentNum6"
                :show-overflow-tooltip="true"
                label="实际数量"
                width="100"
            >
              <template slot-scope="scope">
                <div class="h-line w-line" @click="chakan(scope.row,6)">{{ scope.row.fxAgentNum6 }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="sub6"
                :show-overflow-tooltip="true"
                label="差异(实际-目标)"
                width="100"
            >
            </el-table-column>
<el-table-column
                prop="sale6"
                :show-overflow-tooltip="true"
                label="下单金额"
                width="100"
            >
            </el-table-column>
            <el-table-column
                prop="service6"
                :show-overflow-tooltip="true"
                label="安装金额"
                width="100"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column label="7月分销商上平台" :show-overflow-tooltip="true">
            <el-table-column
                prop="goalNum7"
                :show-overflow-tooltip="true"
                label="目标数量"
                width="100"
            >
            </el-table-column>
            <el-table-column
                prop="fxAgentNum7"
                :show-overflow-tooltip="true"
                label="实际数量"
                width="100"
            >
              <template slot-scope="scope">
                <div class="h-line w-line" @click="chakan(scope.row,7)">{{ scope.row.fxAgentNum7 }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="sub7"
                :show-overflow-tooltip="true"
                label="差异(实际-目标)"
                width="100"
            >
            </el-table-column>
<el-table-column
                prop="sale7"
                :show-overflow-tooltip="true"
                label="下单金额"
                width="100"
            >
            </el-table-column>
            <el-table-column
                prop="service7"
                :show-overflow-tooltip="true"
                label="安装金额"
                width="100"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column label="8月分销商上平台" :show-overflow-tooltip="true">
            <el-table-column
                prop="goalNum8"
                :show-overflow-tooltip="true"
                label="目标数量"
                width="100"
            >
            </el-table-column>
            <el-table-column
                prop="fxAgentNum8"
                :show-overflow-tooltip="true"
                label="实际数量"
                width="100"
            >
              <template slot-scope="scope">
                <div class="h-line w-line" @click="chakan(scope.row,8)">{{ scope.row.fxAgentNum8 }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="sub8"
                :show-overflow-tooltip="true"
                label="差异(实际-目标)"
                width="100"
            >
            </el-table-column>
<el-table-column
                prop="sale8"
                :show-overflow-tooltip="true"
                label="下单金额"
                width="100"
            >
            </el-table-column>
            <el-table-column
                prop="service8"
                :show-overflow-tooltip="true"
                label="安装金额"
                width="100"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column label="9月分销商上平台" :show-overflow-tooltip="true">
            <el-table-column
                prop="goalNum9"
                :show-overflow-tooltip="true"
                label="目标数量"
                width="100"
            >
            </el-table-column>
            <el-table-column
                prop="fxAgentNum9"
                :show-overflow-tooltip="true"
                label="实际数量"
                width="100"
            >
              <template slot-scope="scope">
                <div class="h-line w-line" @click="chakan(scope.row,9)">{{ scope.row.fxAgentNum9 }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="sub9"
                :show-overflow-tooltip="true"
                label="差异(实际-目标)"
                width="100"
            >
            </el-table-column>
<el-table-column
                prop="sale9"
                :show-overflow-tooltip="true"
                label="下单金额"
                width="100"
            >
            </el-table-column>
            <el-table-column
                prop="service9"
                :show-overflow-tooltip="true"
                label="安装金额"
                width="100"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column label="10月分销商上平台" :show-overflow-tooltip="true">
            <el-table-column
                prop="goalNum10"
                :show-overflow-tooltip="true"
                label="目标数量"
                width="100"
            >
            </el-table-column>
            <el-table-column
                prop="fxAgentNum10"
                :show-overflow-tooltip="true"
                label="实际数量"
                width="100"
            >
              <template slot-scope="scope">
                <div class="h-line w-line" @click="chakan(scope.row,10)">{{ scope.row.fxAgentNum10 }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="sub10"
                :show-overflow-tooltip="true"
                label="差异(实际-目标)"
                width="100"
            >
            </el-table-column>
<el-table-column
                prop="sale10"
                :show-overflow-tooltip="true"
                label="下单金额"
                width="100"
            >
            </el-table-column>
            <el-table-column
                prop="service10"
                :show-overflow-tooltip="true"
                label="安装金额"
                width="100"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column label="11月分销商上平台" :show-overflow-tooltip="true">
            <el-table-column
                prop="goalNum11"
                :show-overflow-tooltip="true"
                label="目标数量"
                width="100"
            >
            </el-table-column>
            <el-table-column
                prop="fxAgentNum11"
                :show-overflow-tooltip="true"
                label="实际数量"
                width="100"
            >
              <template slot-scope="scope">
                <div class="h-line w-line" @click="chakan(scope.row,11)">{{ scope.row.fxAgentNum11 }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="sub11"
                :show-overflow-tooltip="true"
                label="差异(实际-目标)"
                width="100"
            >
            </el-table-column>
<el-table-column
                prop="sale11"
                :show-overflow-tooltip="true"
                label="下单金额"
                width="100"
            >
            </el-table-column>
            <el-table-column
                prop="service11"
                :show-overflow-tooltip="true"
                label="安装金额"
                width="100"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column label="12月分销商上平台" :show-overflow-tooltip="true">
            <el-table-column
                prop="goalNum12"
                :show-overflow-tooltip="true"
                label="目标数量"
                width="100"
            >
            </el-table-column>
            <el-table-column
                prop="fxAgentNum12"
                :show-overflow-tooltip="true"
                label="实际数量"
                width="100"
            >
              <template slot-scope="scope">
                <div class="h-line w-line" @click="chakan(scope.row,12)">{{ scope.row.fxAgentNum12 }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="sub12"
                :show-overflow-tooltip="true"
                label="差异(实际-目标)"
                width="100"
            >
            </el-table-column>
<el-table-column
                prop="sale12"
                :show-overflow-tooltip="true"
                label="下单金额"
                width="100"
            >
            </el-table-column>
            <el-table-column
                prop="service12"
                :show-overflow-tooltip="true"
                label="安装金额"
                width="100"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column label="全年分销商上平台" :show-overflow-tooltip="true">
            <el-table-column
                prop="goalNum12"
                :show-overflow-tooltip="true"
                label="目标数量"
                width="100"
            >
            </el-table-column>
            <el-table-column
                prop="fxAgentNum12"
                :show-overflow-tooltip="true"
                label="实际数量"
                width="100"
            >
              <template slot-scope="scope">
                <div class="h-line w-line" @click="chakan(scope.row,12)">{{ scope.row.fxAgentNum12 }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="sub12"
                :show-overflow-tooltip="true"
                label="差异(实际-目标)"
                width="100"
            >
            </el-table-column>
            <el-table-column
                prop="saleYear"
                :show-overflow-tooltip="true"
                label="下单金额"
                width="100"
            >
            </el-table-column>
            <el-table-column
                prop="serviceYear"
                :show-overflow-tooltip="true"
                label="安装金额"
                width="100"
            >
            </el-table-column>
          </el-table-column>
        </el-table>
        <div class="h-tableB h-mrt30">
          <div class="h-tableBL">
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出
            </el-button>
          </div>
          <div class="h-pagination2">
            <pagination :page="q" @query="search"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ss from '../../../api/SystemService'
import updownfile from '../../../utils/updownfile'

export default {
  components: {},
  data() {
    return {
      // 展开折叠筛选
      isScreen: false,
      closeScreen: require("@/assets/images/pimg/closeallic.png"),
      drawScreen: require("@/assets/images/pimg/dobleArr.png"),
      q: {
        year: new Date().getFullYear().toString(),
        pageSize: 10,
        pageNo: 1,
        total: 0
      },
      //table列表
      tableData: [],
      countlist:'',
      lv:'',
    }
  },
  created() {
    this.q = {
      year: new Date().getFullYear().toString(),
      pageSize: 10,
      pageNo: 1,
      total: 0
    };
    this.search();
  },
  methods: {
    //重置
    reset() {
      this.q = {
        year: new Date().getFullYear().toString(),
        pageSize: 10,
        pageNo: 1,
        total: 0
      },
          this.search();
    },
    search(){
      this.query();
      this.queryTotal();
    },
    //查询table
    query() {
      ss.fanli.selectFxServiceNumPage(this.q).then(rd => {
        this.q.total = rd.total;
        this.tableData = rd.records;
      });
    },
    queryTotal() {
      ss.fanli.selectFxServiceNumTotal(this.q).then(rd=>{
        this.lv = rd;
      });

    },
    //批量导出
    exportExcel() {
      updownfile.down("/api/swyl/v1/fanli/flFxServiceOrder/FxAgentNumDownloadExcel", this.q, "post");
    },
    //点击查看详情
    chakan(item,month) {
      console.log('行', item)
      this.$router.push({
        path: '/establish/fxServiceNumDetailTable',
        query: {
          year: item.year,
          month: month,
          oneLevelAgent: item.oneLevelAgent,
          field: item.field,
        }
      });
    },
    //求和汇总
    getSummaries(param){
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        console.log(column,index)
        if (index === 0) {
          sums[index] = '总计';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[4] = this.lv.goalNum1;
          sums[5] = this.lv.fxAgentNum1;
          sums[6] = this.lv.sub1;
          sums[7] = Number(this.lv.sale1).toFixed(2);
          sums[8] = Number(this.lv.service1).toFixed(2);
          sums[9] = this.lv.goalNum2;
          sums[10] = this.lv.fxAgentNum2;
          sums[11] = this.lv.sub2;
          sums[12] = Number(this.lv.sale2).toFixed(2);
          sums[13] = Number(this.lv.service2).toFixed(2);
          sums[14] = this.lv.goalNum3;
          sums[15] = this.lv.fxAgentNum3;
          sums[16] = this.lv.sub3;
          sums[17] = Number(this.lv.sale3).toFixed(2);
          sums[18] = Number(this.lv.service3).toFixed(2);
          sums[19] = this.lv.goalNum4;
          sums[20] = this.lv.fxAgentNum4;
          sums[21] = this.lv.sub4;
          sums[22] = Number(this.lv.sale4).toFixed(2);
          sums[23] = Number(this.lv.service4).toFixed(2);
          sums[24] = this.lv.goalNum5;
          sums[25] = this.lv.fxAgentNum5;
          sums[26] = this.lv.sub5;
          sums[27] = Number(this.lv.sale5).toFixed(2);
          sums[27] = Number(this.lv.service5).toFixed(2);
          sums[28] = this.lv.goalNum6;
          sums[30] = this.lv.fxAgentNum6;
          sums[31] = this.lv.sub6;
          sums[32] = Number(this.lv.sale6).toFixed(2);
          sums[33] = Number(this.lv.service6).toFixed(2);
          sums[34] = this.lv.goalNum7;
          sums[35] = this.lv.fxAgentNum7;
          sums[36] = this.lv.sub7;
          sums[37] = Number(this.lv.sale7).toFixed(2);
          sums[38] = Number(this.lv.service7).toFixed(2);
          sums[39] = this.lv.goalNum8;
          sums[40] = this.lv.fxAgentNum8;
          sums[41] = this.lv.sub8;
          sums[42] = Number(this.lv.sale8).toFixed(2);
          sums[43] = Number(this.lv.service8).toFixed(2);
          sums[44] = this.lv.goalNum9;
          sums[45] = this.lv.fxAgentNum9;
          sums[46] = this.lv.sub9;
          sums[47] = Number(this.lv.sale9).toFixed(2);
          sums[48] = Number(this.lv.service9).toFixed(2);
          sums[49] = this.lv.goalNum10;
          sums[50] = this.lv.fxAgentNum10;
          sums[51] = this.lv.sub10;
          sums[52] = Number(this.lv.sale10).toFixed(2);
          sums[53] = Number(this.lv.service10).toFixed(2);
          sums[54] = this.lv.goalNum11;
          sums[55] = this.lv.fxAgentNum11;
          sums[56] = this.lv.sub11;
          sums[57] = Number(this.lv.sale11).toFixed(2);
          sums[58] = Number(this.lv.service11).toFixed(2);
          sums[59] = this.lv.goalNum12;
          sums[60] = this.lv.fxAgentNum12;
          sums[61] = this.lv.sub12;
          sums[62] = Number(this.lv.sale12).toFixed(2);
          sums[63] = Number(this.lv.service12).toFixed(2);
          sums[64] = this.lv.goalNum12;
          sums[65] = this.lv.fxAgentNum12;
          sums[66] = this.lv.sub12;
          sums[67] = Number(this.lv.saleYear).toFixed(2);
          sums[68] = Number(this.lv.serviceYear).toFixed(2);
        } else {
          sums[0] = '';
          sums[1] = '';
          sums[2] = '';
          sums[3] = '';
        }
      });
      return sums;
    },
  }
}
</script>
<style lang="scss">
.el-table thead.is-group th {
  background-color: #57aefe;
}

.w-content .el-table__footer-wrapper .cell {
  text-align: right;
}

.w-content .el-table__fixed-footer-wrapper tbody td {
  background: #cce7ff;
}

.w-content .el-table__footer-wrapper tbody td {
  background: #cce7ff;
}

.el-table--scrollable-x .el-table__body-wrapper {
  z-index: 1;
}

.el-table__fixed, .el-table__fixed-right {
  box-shadow: none;
}

.el-table__fixed, .el-table__fixed-right {
  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    content: '';
    z-index: 100;
    box-shadow: 0 0 10px rgba(0, 0, 0, .12);
  }
}

.el-table__fixed-footer-wrapper tbody td {
  border-top: 0;
}
.w-line {
  text-decoration: underline;
  cursor: pointer; /* 鼠标悬停时显示手形图标 */
  color: blue;
}
.w-line:hover {
  color: darkblue; /* 鼠标悬停时的颜色 */
}
</style>
